(function () {
  'use strict';

  var loader = document.currentScript;
  var source = loader && loader.dataset.rpfSource;
  var loading = null;
  var ready = false;
  var interactiveSelector = [
    '[data-mega-toggle]',
    '[data-mega-tab]',
    '[data-open-drawer]',
    '[data-close-drawer]',
    '[data-finder-submit]',
    '[data-gallery-thumb]',
    '[data-qty]',
    '[role="tab"]',
    '[data-add-button]',
    '[data-whatsapp-product]',
    '[data-whatsapp-context]',
    '[data-cart-drawer-open]',
    '[data-cart-drawer-close]',
    '[data-cart-drawer-quantity]',
    '[data-cart-drawer-remove]',
    '[data-carousel-prev]',
    '[data-carousel-next]',
    '[data-carousel-dot]',
    '[data-carousel-pause]'
  ].join(',');

  function load() {
    if (!source) return Promise.resolve();
    if (!loading) {
      loading = import(source).then(function () { ready = true; });
    }
    return loading;
  }

  ['pointerover', 'focusin', 'touchstart'].forEach(function (eventName) {
    document.addEventListener(eventName, load, { once: true, passive: true, capture: true });
  });

  document.addEventListener('click', function (event) {
    if (ready) return;
    var control = event.target.closest(interactiveSelector);
    if (!control) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    load().then(function () { control.click(); });
  }, true);

  document.addEventListener('submit', function (event) {
    if (ready || !event.target.matches('[data-add-form]')) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    var form = event.target;
    var submitter = event.submitter;
    load().then(function () {
      if (form.requestSubmit) form.requestSubmit(submitter);
      else form.submit();
    });
  }, true);

  document.addEventListener('change', function (event) {
    if (ready || !event.target.matches('[data-auto-submit]')) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    var field = event.target;
    load().then(function () { field.dispatchEvent(new Event('change', { bubbles: true })); });
  }, true);

  document.addEventListener('shopify:section:load', load, { once: true });
  document.addEventListener('shopify:section:select', load, { once: true });
}());
